import { subscribeMzConsent } from './mz';

// A safe initial state for every consent provider.
export const deniedGoogleConsent = () => ({
	analytics_storage:  'denied',
	ad_storage:         'denied',
	ad_user_data:       'denied',
	ad_personalization: 'denied',
});

// Providers expose explicit choice, GTM eligibility, Google permissions, and optional container event data.
export const subscribeToConsent = (provider, source, listener) => {
	listener({ hasExplicitChoice: false, tagManagerAllowed: false, google: deniedGoogleConsent(), googleConsentPublished: source === 'local' });
	if (provider === 'mz' && ['local', 'parent'].includes(source)) return subscribeMzConsent(source, listener);

	// Unsupported providers must never implicitly enable optional tracking.
	return () => {};
};
